"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const RadioGroup_1 = __importDefault(require("@mui/material/RadioGroup"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Radio_1 = __importDefault(require("@mui/material/Radio"));
const wrapper_component_1 = require("@/room/room_create/wrapper_component");
function default_1() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const snstype = (0, react_redux_1.useSelector)((state) => state.roomData.snstype);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(wrapper_component_1.LowerSectionWrapper, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle2 gray-80" }, { children: t('구매자 SNS계정 수집') })), (0, jsx_runtime_1.jsxs)(RadioGroup_1.default, Object.assign({ value: snstype, onChange: e => dispatch((0, roomCreateStore_1.setSnsType)(e.target.value)), sx: {
                    rowGap: '16px',
                    '.MuiFormControlLabel-root': {
                        height: '22px',
                        m: 0,
                        ml: '-4px',
                    },
                    '.MuiFormControlLabel-label': {
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: '4px',
                        ml: '4px',
                    },
                } }, { children: [(0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { value: "no_sns", control: (0, jsx_runtime_1.jsx)(Radio_1.default, { color: "secondary" }), label: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: t('안 받을게요') })) }), (0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { value: "twitter", control: (0, jsx_runtime_1.jsx)(Radio_1.default, { color: "secondary" }), label: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: "twitter" })) }), (0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { value: "instagram", control: (0, jsx_runtime_1.jsx)(Radio_1.default, { color: "secondary" }), label: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: "instagram" })) })] }))] }));
}
exports.default = default_1;
